exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".canmap {\n  position: relative;\n  border-radius: 10px;\n  height: 250px;\n  width: 100%; }\n\n.canmap canvas#canvas-front {\n  width: 100%;\n  height: 100%;\n  border: 1px dashed #999;\n  border-radius: 10px;\n  position: absolute;\n  z-index: 2; }\n\n.canmap canvas#canvas-back {\n  width: 100%;\n  height: 100%;\n  border: 1px dashed #999;\n  border-radius: 10px;\n  position: absolute;\n  z-index: 1; }\n\n.canmap i {\n  font-size: 20px;\n  z-index: 3; }\n\n.canmap .cantool {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  cursor: pointer; }\n\n.canmap .canmode {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n  cursor: pointer; }\n\n.canmap.disabled {\n  background: #e1e6ef; }\n\nimg {\n  width: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/nbinput/nbinput-sign.component.scss
// module id = 160
// module chunks = 0 1